<ng-template #componentTemplate>
  <div id="conteneur-contact-complet" class="conteneur-contact-complet-cnaf collapsable-cnaf space-above">
    <div *ngIf="!geolocalise">
      <div class="row">
        <div class="col-xs-3 picto-carte-france"></div>
        <div class="col-xs-9">
          <p>Pour accéder aux contacts de votre Caf, vous devez indiquer votre code postal.</p>
          <a class="underline" href="javascript:void(0);" (click)="displayPopupGeolocTs(true)">Localisez vous</a>
        </div>
      </div>
    </div>
    <div *ngIf="geolocalise" [ngSwitch]="etat">
      <div class="col-sm-12 espacement" *ngSwitchCase="'loading'">
        <div class="progress">
          <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="40"
            aria-valuemin="0" aria-valuemax="100">
            Chargement en cours...
          </div>
        </div>
      </div>
      <div class="col-sm-12 espacement" *ngSwitchCase="'error'">
        <div class="alert alert-danger" role="alert">
          <span class="glyphicon glyphicon-alert" aria-hidden="true"></span>
          <p class="inline-cnaf">Un incident technique s'est produit.
            <br aria-hidden="true">Merci de réessayer plus tard.
          </p>
        </div>
      </div>

      <div *ngSwitchCase="'loaded'">
        <div class="row" *ngIf="banner">
          <div class="col-sm-12">
            <div class="bloc-banner bg-bleu-caf">
              <p class="h5 texte-blanc-cnaf texte-banner" [innerHTML]="banner"></p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12" id="ancre-contenu">
            <h2 class="espacement">Vous souhaitez nous contacter par écrit ?</h2>
            <div class="row liseret-flex">
              <div class="col-sm-12 col-md-5">
                <h3 class="picto-contacter-cnaf picto-courrier">Par courrier</h3>
                <p class="espacement">Joignez nous par courrier. Nous vous répondrons
                  dans les meilleurs délais.</p>
                <p>
                  <span class="btn-block texte-bold">{{nom}}</span>
                  <span class="btn-block texte-bold">{{adrsComp}}</span>
                  <span class="btn-block texte-bold">{{voie}}</span>
                  <span class="btn-block texte-bold">{{cp}}</span>
                </p>
                <p><strong>Important : </strong>pour plus de lisibilité écrivez l'adresse en noir et en
                  majuscule</p>
              </div>
              <div class="hidden-xs hidden-sm col-md-1 limite-haute">
                <div class="affiche-liseret filet-right-cnaf"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="filet-cnaf filet-bottom-cnaf" *ngIf="!logged"></div>

        <div class="row espacement-cnaf" *ngIf="!logged">
          <div class="col-sm-12">
            <h2 class="espacement">Ma Caf en toute autonomie</h2>
            <p>Vous pouvez réaliser des démarches ou consulter vos
              informations
              personnelles directement depuis votre espace
              Caf.</p>
            <div class="bloc-couleur cnaf-background1">
              <p class="h4 centrer bleu-caf">Accéder à vos services en ligne</p>
              <p class="centrer">Consultez vos droits, vos paiements, imprimer
                une
                attestation,mettre
                à jour votre situation, transmettre un document...</p>
              <div class="centrer">
                <a class="btn btn-primary-cnaf" href="/redirect/s/Redirect?page=applimobileMonCompte">Me connecter</a>
              </div>
            </div>
          </div>
        </div>
        <div class="filet-cnaf filet-bottom-cnaf"></div>
        <div class="row espacement-cnaf">
          <div class="col-sm-12">
            <h2 class="espacement">Vous souhaitez parler à un conseiller ?</h2>
            <h3 class="picto-contacter-cnaf picto-telephone">Par téléphone</h3>
            <ng-container *ngIf="usagerAutoriseSviVisuel">
              <cnaf-contacter-caf-svi (loading)="appellerCaf($event)" [etudiant]="etudiant" [horaire]="horaire"
                [disponibiliteFileSviVisuel]="disponibiliteFileSviVisuel"></cnaf-contacter-caf-svi>
            </ng-container>
            <ng-container *ngIf="!usagerAutoriseSviVisuel">
              <div class="row">
                <div class="col-sm-7">
                  <p class="espacement">Echangez en direct avec un conseiller
                    de
                    la Caf sans
                    vous
                    déplacer {{horaire}} </p>
                </div>
                <div class="col-sm-5 center">
                  <a class="logo-3230 zone-lien-telephone btn-block espacement-cnaf" href="tel:3230" target="_system"
                    *ngIf="!profilMayotte">
                    <span class="sr-only">Téléphone </span>
                    <span class="sr-only">3230 (service gratuit + prix appel)</span>
                  </a>
                  <a class="picto picto-sva-cnaf tel-cnaf tel-cartouche-sva-cnaf tel-mayotte espacement zone-lien-telephone"
                    href="tel:0269619191" target="_system" *ngIf="profilMayotte">
                    <span class="sr-only">Téléphone </span>
                    <strong title="0 269 61 91 91" class="innertel-cnaf">0 269 61 91 91</strong>
                    <span>Prix d'un appel local</span>
                  </a>
                </div>
              </div>
              <p><strong>Vous êtes étudiant ?</strong></p>
              <div class="row">
                <div class="col-sm-7">
                  <p>Echangez en direct avec un conseiller sur une ligne téléphonique dédiée du lundi au vendredi de {{horaireEtudiant}}
                  </p>
                </div>
                <div class="col-sm-5">
                  <a class="logo-TelEtu zone-lien-telephone btn-block espacement-cnaf" href="tel:0969325252"
                    target="_system">
                    <span class="sr-only">Téléphone Etudiant</span>
                    <span class="sr-only">0 969 32 52 52 (service gratuit + prix appel)</span>
                  </a>
                </div>
              </div>
            </ng-container>

            <div class="bloc-couleur cnaf-background1 bloc-sourd row">
              <div class="col-md-offset-1 col-md-10">
                <h3 class="picto-sourd bleu-caf espacement">Vous êtes sourd ou malentendant ?</h3>
                <p>Faites vous accompagner en visio-interprétation et
                  choisissez le
                  mode de communication qui vous convient; LSF (Langue des signes française), TTRP (Transcription en
                  temps réel de la parole) ou LCP (Langue française parlée complétée).</p>
                <p>
                  <strong>Attention! Vous devez être équipé d'une webcam et d'une connexion
                    internet.
                    Si
                    vous souhaitez obtenir des renseignements sur votre dossier, vous devrez indiquer votre n° de
                    Sécurité
                    sociale et répondre à des questions pour s'assurer de votre identité.</strong>
                </p>
                <a class="btn btn-secondary-cnaf marginzero"
                  href="/redirect/s/Redirect?page=sourdsEtMalentendants">Accéder au service</a>
              </div>
            </div>
          </div>
        </div>
        <div class="filet-cnaf filet-bottom-cnaf" *ngIf="presencePriseRendezVous"></div>

        <div class="row espacement-cnaf" *ngIf="presencePriseRendezVous">
          <div class="col-sm-12">
            <h2 class="espacement">Vous souhaitez être accompagné dans vos démarches ?</h2>
            <h3 class="picto-contacter-cnaf picto-rdv">Sur rendez-vous</h3>
            <div class="row">
              <div class="col-sm-12 col-md-7">
                <p *ngIf="!isCafPilote" class="espacement">Prenez le temps privilégié avec un de nos conseillers Caf
                  pour faire le point sur votre dossier.</p>
                <p class="espacement">Selon votre Caf, vous pourrez choisir parmi les options suivantes :</p>
                <ul>
                  <li>en physique</li>
                  <li>par téléphone</li>
                  <li>en visio</li>
                </ul>
              </div>
              <div class="col-sm-12 col-md-5">
                <a *ngIf="ouvertureNouvelleFenetrePourPriseRendezVous && pageRdv"
                  class="btn btn-primary-cnaf espacement min-width" target="_blank" href="javascript:void(0);"
                  (click)="clickDemanderRdv()">
                  {{btnRdvName}}</a>
                <a *ngIf="!ouvertureNouvelleFenetrePourPriseRendezVous && pageRdv"
                  class="btn btn-primary-cnaf espacement min-width" href="javascript:void(0);"
                  (click)="clickDemanderRdv()">
                  {{btnRdvName}}</a>
                <a *ngIf="isNational && annulationRDV && !isNotLoggedCafPilote"
                  class="btn btn-secondary-cnaf espacement ajustement min-width" href="javascript:void(0);"
                  (click)="clickAnnulerRdv()">
                  Annuler ou modifier un rendez-vous</a>
              </div>
            </div>
          </div>
        </div>
        <div class="filet-cnaf filet-bottom-cnaf" *ngIf="afficheSectionPointAccueil"></div>

        <div class="row" *ngIf="afficheSectionPointAccueil">
          <div class="col-sm-12">

            <h2 class="espacement">Vous préférez vous déplacer ?</h2>
            <h3 class="picto-contacter-cnaf picto-accueil">Point d'accueil</h3>
            <div class="row">
              <div class="col-sm-7">
                <p class="espacement">Retrouvez la liste des points d'accueil de
                  votre
                  Caf (adresses, horaires d'ouverture, services proposés...)</p>
              </div>
              <div class="col-sm-5 centrer" *ngIf="pagePointsAccueil">
                <a class="btn btn-primary-cnaf espacement" [href]="pagePointsAccueil">Trouver un point accueil Caf</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-questions [hidden]="etat === 'loading'"></app-questions>
  </div>
</ng-template>